export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_50-6622ca174cb5f672e223e75b47a65620.jpg";